(function(EF) {
  EF.services = EF.services || {};

  EF.services.audio_player = (function() {
    var service = {
      initPlayer: function(config) {
        if(window.MediaElement) {
          service.audio_element = new window.MediaElement(config.audio_element_id, {
            success: function() {
              service.flashReady = true;
              if(service.flashSource) {
                console.log('starting an audio file on flash success callback');
                //service.playing.setSrc(audio_file.source);
              }
              if(service.playing) {
                canplaythrough();
              }
            }
          });
        }
        else {
          var message = 'To use the audio_player you must include MediaElement.js.';
          var err = new Error(message);
          throw (err);
        }
        service.config = config;
        service.storage = window.LocalStorageWrapper;
        service.is_muted = (service.storage.getItem('is_muted') == 'true');
        service.is_narration_needed = (service.storage.getItem('is_narration_needed') == 'true');

      },
      initAudio: function(audio_file, options, callbacks) {
        service.options = options === null || options === undefined ? {} : options;
        if(service.options.autoPlay === undefined) {
          service.options.autoPlay = true;
        }
        service.callbacks = callbacks === null || callbacks === undefined ? {} : callbacks;

        service.playing = service.audio_element;
        service.audio_started = false;

        if(audio_file.narration) {
          service.narrationPresent = true;
          service.setNarration(audio_file.narration);
        } else {
          service.narrationPresent = false;
          service.hideNarration();
        }
        if(service.config.onAudioInit) {
          service.config.onAudioInit();
        }

        service.playing.addEventListener('canplaythrough', canplaythrough);
        service.playing.addEventListener('play', play);
        service.playing.addEventListener('timeupdate', timeupdate);
        service.playing.addEventListener('ended', ended);
        if(service.flashReady) {
          service.playing.setSrc(audio_file.source);
        } else {
          console.log('tried to start an audio file, but flash wasn\'t ready');
          service.flashSource = audio_file.source;
        }
        service.isPlaying = false;

        if(service.playing.pluginType === 'flash' && service.options.autoPlay && service.flashReady) {
          canplaythrough();
        }
      },
      skipAudio: function() {
        service.playing.pause();
        if(service.options.slides) {
          var i = 0;
          var slideKeys = Object.keys(service.options.slides.timers);
          (function slideLoop() {
            setTimeout(function() {
              service.playSlideMethod(service.options.slides.timers[slideKeys[i]]);
              i++;
              if(i < slideKeys.length) {
                slideLoop();
              } else {
                setTimeout(ended, 1000);
              }
            }, 1000);
          })();
        } else {
          ended();
        }
      },
      mediaPlayPause: function() {
        if(service.playing !== null) {
          if(!service.isPlaying) {
            service.mediaPlay(true);
          } else {
            service.mediaPause();
          }
        }
      },
      mediaPlay: function(canPause) {
        if(service.playing !== null) {
          if(service.config.onPlay) {
            service.config.onPlay(canPause, service.narrationPresent);
          }
          if(service.is_muted) {
            service.mute();
          } else {
            service.unmute();
          }
          if(service.is_narration_needed && service.narrationPresent) {
            service.showNarration();
          } else {
            service.hideNarration();
          }
          service.playing.play();
          service.isPlaying = true;
        }
      },
      mediaPause: function() {
        if(service.playing !== null)
          service.playing.pause();
        service.isPlaying = false;
        if(service.config.onPause) {
          service.config.onPause();
        }
      },
      playSlides: function() {
        var current_playing_time = Math.floor(service.playing.currentTime);
        var method = service.options.slides.timers[current_playing_time];
        if(method) {
          service.playSlideMethod(method);
        }
      },
      playSlideMethod: function(method) {
        var position = $.inArray(method, service.methods);
        if(position == -1) {
          if(service.options.slides.methods[method]) {
            service.methods.push(method);
            service.options.slides.methods[method].call();
          } else {
            throw 'Tried to call method ' + method + ', while playing ' + service.playing.currentSrc + ' but it did not exist.';
          }
        }
      },
      setNarration: function(narration_text) {
        service.narration = narration_text;
        if(service.config.setNarration) {
          service.config.setNarration(narration_text);
        }
      },
      playing: null,
      methods: [],
      is_muted: false,
      is_narration_needed: false,
      muteUnmute: function() {
        if(service.playing !== null) {
          if(service.is_muted) {
            service.storage.setItem('is_muted', 'false');
            service.is_muted = false;
            service.unmute();
          } else {
            service.storage.setItem('is_muted', 'true');
            service.is_muted = true;
            service.mute();
          }
        }
      },
      mute: function() {
        service.playing.setMuted(true);
        if(service.options.loop && service.playing) {
          service.playing.pause();
        }
        if(service.config.onMute) {
          service.config.onMute();
        }
      },
      unmute: function() {
        service.playing.setMuted(false);
        if(service.options.loop && service.playing) {
          service.playing.play();
        }
        if(service.config.onUnMute) {
          service.config.onUnMute();
        }
      },
      toggleNarration: function() {
        if(service.is_narration_needed) {
          service.is_narration_needed = false;
          service.storage.setItem('is_narration_needed', 'false');
          service.hideNarration();
        } else {
          service.is_narration_needed = true;
          service.storage.setItem('is_narration_needed', 'true');
          service.showNarration();
        }
      },
      showNarration: function() {
        if(service.config.showNarration) {
          service.config.showNarration();
        }
      },
      hideNarration: function() {
        if(service.config.hideNarration) {
          service.config.hideNarration();
        }
      },
      clear: function() {
        if(service.playing !== null) {
          service.playing.pause();
          service.isPlaying = false;

          service.playing.removeEventListener('canplaythrough', canplaythrough);
          service.playing.removeEventListener('play', play);
          service.playing.removeEventListener('timeupdate', timeupdate);
          service.playing.removeEventListener('ended', ended);

          service.playing.setSrc('');
          service.playing = null;
          service.methods = [];

          service.hideNarration();
        }
      }
    };

    function canplaythrough() {
      if(service.options.autoPlay) {
        service.mediaPlay(!service.options.loop);
      }
      if(service.config.canPlayThrough) {
        service.config.canPlayThrough(service.options.clickToPlay);
      }
      if(service.callbacks.canplaythrough) {
        service.callbacks.canplaythrough();
      }
    }
    function play() {
      if(service.audio_started === false) {
        service.audio_started = true;
        if(service.options.slides && service.options.slides.start) {
          service.playSlideMethod(service.options.slides.start);
        }
        if(service.callbacks.play) {
          service.callbacks.play();
        }
      }
    }
    function timeupdate() {
      if(service.options.slides) {
        service.playSlides();
      }
      if(service.callbacks.timeupdate) {
        service.callbacks.timeupdate(service.playing);
      }
    }
    function ended() {
      if(service.options.loop && service.playing) {
        if(service.playing.readyState > 0) {
          service.playing.setCurrentTime(0);
        }
        service.playing.pause();
        service.mediaPlay();
      } else {
        service.clear();
      }
      if(service.config.onAudioEnded) {
        service.config.onAudioEnded(service.options);
      }
      if(service.callbacks.ended) {
        service.callbacks.ended();
      }
    }

    return service;
  })();

})(window.EF);
